import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.svg';
import { ContactDialog } from '@/components/contact/ContactDialog';

export const Footer = () => {
  const [contactOpen, setContactOpen] = useState(false);
  return (
  <>
  <footer className="relative z-10 border-t py-12 px-6" style={{ backgroundColor: '#1A2B3C', borderColor: '#1A2B3C' }}>
    <div className="max-w-7xl mx-auto">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        <div>
          <div className="mb-4">
            <img src={logo} alt="Applyt" className="h-[44px] brightness-0 invert" />
          </div>
          <p style={{ color: '#C5D2E0' }} className="leading-relaxed">
            An AI skill-based expertise execution platform that generates finished work.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold mb-4" style={{ color: '#E1E8F0' }}>Product</h4>
          <ul className="space-y-2" style={{ color: '#C5D2E0' }}>
            <li><a href="/lenses" className="hover:text-white transition-colors">Experts</a></li>
            <li><a href="/lenses" className="hover:text-white transition-colors">Expert Skills</a></li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold mb-4" style={{ color: '#E1E8F0' }}>Company</h4>
          <ul className="space-y-2" style={{ color: '#C5D2E0' }}>
            <li><a href="#" className="hover:text-white transition-colors">About</a></li>
            <li><a href="#" className="hover:text-white transition-colors">Press</a></li>
            <li>
              <button
                type="button"
                onClick={() => setContactOpen(true)}
                className="hover:text-white transition-colors text-left"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-semibold mb-4" style={{ color: '#E1E8F0' }}>Resources</h4>
          <ul className="space-y-2" style={{ color: '#C5D2E0' }}>
            <li><Link to="/plugins/pricing-power-advisor" className="hover:text-white transition-colors">Pricing Power Advisor</Link></li>
            <li><Link to="/guides/strategy-to-execution" className="hover:text-white transition-colors">Strategy to execution guide</Link></li>
            <li><Link to="/guides/business-systems-without-owner" className="hover:text-white transition-colors">Business systems guide</Link></li>
            <li><Link to="/guides/predictable-sales-process" className="hover:text-white transition-colors">Predictable sales guide</Link></li>
            <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
            <li><a href="#" className="hover:text-white transition-colors">API</a></li>
          </ul>
        </div>
      </div>
      
      <div className="pt-8 flex flex-col md:flex-row justify-between items-center" style={{ borderTop: '1px solid #2D4A6F' }}>
        <p style={{ color: '#C5D2E0' }}>© 2026 Eugene Grekov, operating under the Applyt brand. All rights reserved.</p>
        <div className="flex space-x-6 mt-4 md:mt-0">
          <Link to="/privacy" style={{ color: '#E1E8F0' }} className="hover:text-white transition-colors">Privacy</Link>
          <Link to="/terms" style={{ color: '#E1E8F0' }} className="hover:text-white transition-colors">Terms</Link>
          <a href="#" style={{ color: '#E1E8F0' }} className="hover:text-white transition-colors">Security</a>
        </div>
      </div>
      
      <div className="mt-4 text-center">
        <p className="text-xs" style={{ color: '#829AB1' }}>
          Disclosure: AI Lenses are trained on experts' work & methodology; they represent the expert's thinking patterns, not the human expert themselves.
        </p>
      </div>
    </div>
  </footer>
  <ContactDialog
    open={contactOpen}
    onOpenChange={setContactOpen}
    title="Contact Us"
    description="Send us a message and we'll get back to you shortly."
    defaultSubject="General inquiry"
    context="Footer → Contact"
  />
  </>
  );
};
